// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  slot: __t.u64(),
  archetype: __t.string(),
  title: __t.string(),
  pitch: __t.string(),
  asker: __t.string(),
  location: __t.string(),
  locationIndex: __t.u8().name("location_index"),
  minHumans: __t.u8().name("min_humans"),
  maxHumans: __t.u8().name("max_humans"),
  parMinutes: __t.u8().name("par_minutes"),
  side: __t.bool(),
  state: __t.u8(),
  expiresAt: __t.timestamp().name("expires_at"),
  blob: __t.byteArray(),
  blobHash: __t.byteArray().name("blob_hash"),
  createdAt: __t.timestamp().name("created_at"),
});
